module.exports = __webpack_public_path__ + "img/2_en.7f239262.png";